export default __webpack_public_path__ + "static/monitor-illustration-352a31cb6790707c117f80a6f989faf9.svg";